import PropTypes from "prop-types";
import { ContentTitle } from "./content-title.styles.es.js";
const propTypes = {
  as: PropTypes.elementType,
  magnitude: PropTypes.oneOf(["sm", "md", "lg", "xl", "xxl"])
};
const defaultProps = {
  as: void 0,
  magnitude: "sm"
};
ContentTitle.propTypes = propTypes;
ContentTitle.defaultProps = defaultProps;
export {
  ContentTitle
};
